(() => {
  const config = document.getElementById('sm-site-visit-config');
  if (!config) return;
  const api = config.dataset.api;
  const key = 'sm-site-visit-v1';
  const idle = 30 * 60 * 1000;
  const documentId = crypto.randomUUID().replaceAll('-', '');
  let state;
  function read() {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
  }
  function write(value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  }
  function allowed() {
    return config.dataset.track === 'true' && (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function publish(data) {
    if (data.metric !== 'website_visits' || !Number.isSafeInteger(data.count) || data.count < 18188) return;
    window.dispatchEvent(new CustomEvent('sm:site-visits', {detail:data}));
  }
  async function report(countVisit) {
    try {
      const options = {cache:'no-store',signal:AbortSignal.timeout(8000)};
      if (countVisit) Object.assign(options, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({visit_id:state.id})});
      const response = await fetch(api, options);
      if (response.ok) publish(await response.json());
    } catch {}
  }
  function enter(restored) {
    if (!allowed()) { report(false); return; }
    const previous = read();
    let internal = false;
    try { internal = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch {}
    const nav = performance.getEntriesByType('navigation')[0];
    try {
      const from = window.navigation?.activation?.from;
      if (from) internal = !!from.url && new URL(from.url).origin === location.origin;
    } catch {}
    const fresh = !previous || !/^[a-f0-9]{32}$/.test(previous.id || '') || Date.now() - previous.seen >= idle;
    const sameVisit = !fresh && (restored ? previous.documentId !== documentId && !previous.external : nav?.type === 'reload' || (internal && !previous.external));
    state = {id:sameVisit ? previous.id : crypto.randomUUID().replaceAll('-', ''),documentId,seen:Date.now(),external:false};
    if (write(state)) report(true);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!state || !link || event.defaultPrevented || link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      const destination = new URL(link.href,location.href);
      if (destination.protocol === 'https:' || destination.protocol === 'http:') {
        state.external = destination.origin !== location.origin;
        state.seen = Date.now();
        write(state);
      }
    } catch {}
  });
  window.addEventListener('pageshow', event => { if (event.persisted) enter(true); });
  document.addEventListener('visitorConsentCollected', () => { if (!state) enter(false); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && state && allowed()) {
      const latest = read();
      if (latest?.id === state.id) { state.seen = Date.now(); write(state); }
    }
  });
  setInterval(() => {
    if (!document.hidden && state && allowed()) {
      const latest = read();
      if (latest?.id === state.id) { state.seen = Date.now(); write(state); }
    }
  },20000);
  enter(false);
})();
